<div class="outer-container">
    <div class="division">
        <div class="column1">
            <div class="card-container">
                <div class="impact-card">
                    <div class="header">ACTUAL IMPACT</div>
                    <div class="content">
                        ${{ algorithm.actual_impact | numberSuffix : 1 }}
                    </div>
                </div>
                <div class="impact-card">
                    <div class="header">ACTUAL IMPACT %</div>
                    <div class="content" style="color: #0c0c0c">
                        {{ algorithm.actual_impact_per | percent }}
                    </div>
                </div>
            </div>

            <div class="note-container">
                <div class="card">
                    <div class="content">
                        <span class="text reduced-font">
                            Sales growth was {{ algorithm.x | percent }} with a margin growth
                            of {{ algorithm.y | numberSuffix : 1 }} p.p</span>
                        <p>SALES IMPACT</p>
                    </div>
                </div>
                <div class="card">
                    <div class="content">
                        <span class="text reduced-font">
                            Price Impact is ${{ algorithm.a | numberSuffix : 1 }} with an
                            impact percentage of {{ algorithm.b | percent }}</span>
                        <p>PRICE IMPACT</p>
                    </div>
                </div>
                <div class="card">
                    <div class="content">
                        <span class="text reduced-font">
                            Volume Impact is ${{ algorithm.h | numberSuffix : 1 }} with an
                            impact percentage of {{ algorithm.j | percent }}</span>
                        <p>VOLUME IMPACT</p>
                    </div>
                </div>
            </div>

            <div class="note-container margin-top">
                <button class="{{ selectedDi == 'All' ? 'btnClr' : 'btn' }}" (click)="byTrend()">
                    Customer by LOB
                </button>
                <button class="{{ selectedBtn == 'sales' ? 'btnClr' : 'btn' }}" type="submit" value="sales"
                    (click)="salesButton()">
                    Sales Realization
                </button>
                <button class="{{ selectedBtn == 'margin' ? 'btnClr' : 'btn' }}" (click)="marginButton()">
                    Margin Realization
                </button>
            </div>
            <div class="chart-box margin-top">
                <div>
                    <app-cec-ctt-first-fit-customer-by-trend-chart *ngIf="
              selectedDi == 'All' && customerByTrend.length !== 0 && top5Loaded
            " [customerByTrend]="customerByTrend" (onLegendClick)="legendClick($event)"
                        legend="lob"></app-cec-ctt-first-fit-customer-by-trend-chart>

                    <img class="message" *ngIf="
              selectedDi == 'All' && customerByTrend.length === 0 && top5Loaded
            " src="/assets/images/nodata.png" />

                    <app-top5-chart *ngIf="selectedDi !== 'All' && top5.length !== 0 && top5Loaded" [top5]="top5"
                        [button]="selectedDi"></app-top5-chart>

                </div>
                <div>

                    <app-cec-ctt-first-fit-sales-realization-chart source='cssna' *ngIf="
              selectedBtn == 'sales' && salesReal.length !== 0 && dataLoaded
            " [salesReal]="salesReal"></app-cec-ctt-first-fit-sales-realization-chart>

                    <app-cec-ctt-first-fit-margin-realization-chart *ngIf="
              selectedBtn == 'margin' && marginReal.length !== 0 && dataLoaded
            " [marginReal]="marginReal"></app-cec-ctt-first-fit-margin-realization-chart>

                </div>
            </div>
        </div>
        <div class="column2">
            <div class="filter">
                <span (click)="resetFilter()" class="reset"><img src="../../../../../assets/images/clear.png" />&nbsp;
                    RESET</span>
                <span>|</span>
                <button fxFlexAlign="top right" mat-icon-button [matMenuTriggerFor]="filterMenu">
                    Top 5
                </button>

                <mat-menu #filterMenu="matMenu">
                    <div class="pad-menu" fxLayout="column">
                        <mat-radio-group fxLayout="column" class="bottom-separator" [(ngModel)]="radio">
                            <mat-radio-button class="rdbtn" value="model_type"
                                (change)="searchDimension($event.value)">Model Type</mat-radio-button>
                            <mat-radio-button class="rdbtn" value="certification"
                                (change)="searchDimension($event.value)">Certification</mat-radio-button>
                            <mat-radio-button class="rdbtn" value="product_line"
                                (change)="searchDimension($event.value)">Product Line</mat-radio-button>
                            <mat-radio-button class="rdbtn" value="lob" (change)="searchDimension($event.value)">LOB
                            </mat-radio-button>
                            <mat-radio-button class="rdbtn" value="customer_name" (change)="searchDimension($event.value)">Customer
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </mat-menu>
            </div>
            <app-cec-ctt-first-fit-drop-down *ngIf="formDetails" [formDetails]="formDetails"
                [selectedValues]="selectedValues" (onSelectFilter)="searchSalesData($event)"
                [reset]="reset" [pageType]="'fuel-systems'"></app-cec-ctt-first-fit-drop-down>
        </div>
    </div>
</div>
